/*
 * File: SelectedDiagnosesStore.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: mobx store for persisting the list of diagnoses on a post charge form
 */
import { types } from "mobx-state-tree";
import { DiagnosisModel } from "./UISearchStore";

const pointerArray = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L"
];

const SelectedDiagnosesStore = types
  .model("SelectedDiagnosesStore", {
    selectedDiagnoses: types.array(DiagnosisModel)
  })
  .actions(self => ({
    addFormDiagnosis: (code, diagnosis, umlsId) => {
      let index = self.selectedDiagnoses.length;
      let pointer = self.getNewPointer(index);
      let diagnosisObject = { code, diagnosis, pointer, umlsId, index };
      self.selectedDiagnoses.push(diagnosisObject);
    },

    addPatientProblemsToDiagnosesList: patientProblems => {
      self.selectedDiagnoses = [];
      patientProblems.forEach(problem => {
        self.addFormDiagnosis(
          problem.problemCode,
          problem.description,
          problem.problemListUmlsId
        );
      });
    },

    deleteFormDiagnosis: diagnosis => {
      const indexToDelete = self.selectedDiagnoses.indexOf(diagnosis);
      if (indexToDelete > -1) {
        self.selectedDiagnoses.splice(indexToDelete, 1);
      }
      self.setDiagnosesPointers();
    },

    setDiagnosesPointers: () => {
      self.selectedDiagnoses.forEach((element, index) => {
        element.pointer = self.getNewPointer(index);
      });
    }
  }))
  .views(self => ({
    getNewPointer: index => {
      return pointerArray[index];
    },

    diagnosesExistOnForm: () => {
      return self.selectedDiagnoses.length > 0;
    },

    shouldAllowMoreDiagnoses: () => {
      return self.selectedDiagnoses.length < 12;
    },

    getPointerFromUmlsId: umlsId => {
      const diagnosis = self.selectedDiagnoses.find(
        diagnosis => diagnosis.umlsId === umlsId
      );
      return diagnosis.pointer;
    },

    isDuplicateDiagnosis: umlsId => {
      return (
        self.selectedDiagnoses.find(dx => dx.umlsId === umlsId) !== undefined
      );
    }
  }));

export default SelectedDiagnosesStore;
